<template>
  <modal
    id="cookie-banner"
    :show="displayConsentBanner"
    :has-close-button="false"
    :close-on-background-click="false"
    :modifiers="['rounded-border', 'grey-pale']"
    :close-on-escape="false"
    tracking-name="popup-20200728-cookie-banner">
    <template v-slot:disclaimer>
      <cookie-disclaimer
        @consent-all="$emit('consent-all')" />
    </template>
    <template v-slot:settings>
      <cookie-settings
        @consent-all="$emit('consent-all')"
        @consent="options => $emit('consent', options)" />
    </template>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "@/shared/modal";
import CookieDisclaimer from "./cookie-disclaimer";
import CookieSettings from "./cookie-settings";

export default {
  name: "CookieBanner",
  components: {
    Modal,
    CookieDisclaimer,
    CookieSettings
  },
  computed: {
    ...mapGetters(["displayConsentBanner"])
  }
};
</script>
